(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var searchBtns = document.querySelectorAll('[data-js-toggle="searchTogglePopup"]');
    var popup = document.getElementById('headerPopupSearch');
    if (!searchBtns.length || !popup) return;

    var isOpen = false;
    var overlay = null;
    var body = document.body;

    function open() {
      if (isOpen) return;
      isOpen = true;

      overlay = document.createElement('div');
      overlay.className = 'window-overlay';
      overlay.setAttribute('data-js-overlay', 'searchTogglePopup');
      overlay.setAttribute('data-js-window', 'overlay');
      body.appendChild(overlay);
      overlay.offsetHeight;
      overlay.classList.add('is-active');

      popup.classList.add('is-active');
      body.classList.add('is-drawer-active');
      body.style.overflow = 'hidden';

      searchBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      var input = popup.querySelector('.js-predictive-search-input');
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 100);
      }
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      if (overlay) {
        overlay.classList.remove('is-active');
        overlay.remove();
        overlay = null;
      }

      popup.classList.remove('is-active');
      body.classList.remove('is-drawer-active');
      body.style.overflow = '';

      searchBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    searchBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        isOpen ? close() : open();
      });
    });

    document.addEventListener('click', function (e) {
      if (isOpen && e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    // === 购物车数量同步 ===
    // === 产品系列菜单：Hover 开关 + 点击切换 Tab ===
    var megaToggles = document.querySelectorAll('.js-mega-toggle');
    var currentOpen = null;
    var closeTimer = null;

    megaToggles.forEach(function (toggle) {
      var panelId = toggle.getAttribute('data-mega-panel');
      var panel = document.getElementById(panelId);
      if (!panel) return;

      toggle.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        if (currentOpen && currentOpen !== panel) {
          currentOpen.classList.remove('is-active');
        }
        panel.classList.add('is-active');
        currentOpen = panel;
      });

      toggle.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          panel.classList.remove('is-active');
          if (currentOpen === panel) currentOpen = null;
        }, 200);
      });

      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });

      panel.addEventListener('mouseleave', function () {
        panel.classList.remove('is-active');
        if (currentOpen === panel) currentOpen = null;
      });
    });

    // 点击左侧标题 → 切换右侧产品
    document.querySelectorAll('.js-mega-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panel = this.closest('.js-mega-panel');
        var index = this.dataset.megaIndex;

        panel.querySelectorAll('.js-mega-tab').forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');

        panel.querySelectorAll('.js-mega-content').forEach(function (p) {
          p.classList.remove('is-active');
        });
        var target = panel.querySelector('[data-mega-panel="' + index + '"]');
        if (target) {
          target.classList.add('is-active');
          var scroller = panel.querySelector('.collectionitem');
          if (scroller) scroller.scrollTop = 0;
        }
      });
    });

    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen('cart:updated', function (e) {
        var wrapper = document.querySelector('.js-header-cart-item-count-wrapper');
        var countEl = document.querySelector('.js-header-count');
        if (!wrapper || !e || e.item_count === undefined) return;
        wrapper.setAttribute('data-cart-count', e.item_count);
        wrapper.style.display = e.item_count > 0 ? '' : 'none';
        if (countEl) {
          countEl.innerHTML = e.item_count > 99 ? '99+' : e.item_count;
        }
      });
    } else {
      var retries = 0;
      var checkInterval = setInterval(function () {
        retries++;
        var bus = window.themeCore && window.themeCore.EventBus;
        if (bus) {
          clearInterval(checkInterval);
          bus.listen('cart:updated', function (e) {
            var wrapper = document.querySelector('.js-header-cart-item-count-wrapper');
            var countEl = document.querySelector('.js-header-count');
            if (!wrapper || !e || e.item_count === undefined) return;
            wrapper.setAttribute('data-cart-count', e.item_count);
            wrapper.style.display = e.item_count > 0 ? '' : 'none';
            if (countEl) {
              countEl.innerHTML = e.item_count > 99 ? '99+' : e.item_count;
            }
          });
        } else if (retries > 50) {
          clearInterval(checkInterval);
        }
      }, 100);
    }

    (function () {
      var geoBtns = document.querySelectorAll('.js-geodrawer');
      var geoPopup = document.getElementById('geoPopup');
      if (!geoBtns.length || !geoPopup) return;

      var geoParent = geoPopup.parentNode;

      var overlay = document.createElement('div');
      overlay.className = 'window-overlay';
      overlay.setAttribute('data-js-overlay', 'geoPopup');
      overlay.setAttribute('data-js-window', 'overlay');

      function openGeo() {
        document.documentElement.style.overflow = 'hidden';
        document.body.appendChild(geoPopup);
        geoPopup.style.zIndex = '150';
        document.body.appendChild(overlay);
        overlay.offsetHeight;
        overlay.classList.add('is-active');
        geoPopup.classList.add('is-active');
      }
      function closeGeo() {
        document.documentElement.style.removeProperty('overflow');
        overlay.classList.remove('is-active');
        overlay.remove();
        geoPopup.classList.remove('is-active');
        geoParent.appendChild(geoPopup);
      }

      geoBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          geoPopup.classList.contains('is-active') ? closeGeo() : openGeo();
        });
      });
      geoPopup.querySelector('.geo-close').addEventListener('click', function (e) {
        e.stopPropagation();
        closeGeo();
      });
      overlay.addEventListener('click', closeGeo);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && geoPopup.classList.contains('is-active')) closeGeo();
      });

      // === 移动端抽屉叠层修复 ===
      var mobileDrawer = document.getElementById('mobile-menu-drawer');
      if (mobileDrawer) {
        var drawerParent = mobileDrawer.parentNode;
        var observer = new MutationObserver(function () {
          if (mobileDrawer.classList.contains('is-active')) {
            document.body.appendChild(mobileDrawer);
          } else if (mobileDrawer.parentNode === document.body) {
            drawerParent.appendChild(mobileDrawer);
          }
        });
        observer.observe(mobileDrawer, { attributes: true, attributeFilter: ['class'] });
      }

      // === 移动端产品系列面板 ===
      document.querySelectorAll('.js-mobile-collection-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = this.nextElementSibling;
          if (!panel) return;
          // 关闭其他已打开的面板
          document.querySelectorAll('.js-mobile-collection-panel.is-active').forEach(function (open) {
            if (open !== panel) open.classList.remove('is-active');
          });
          panel.classList.add('is-active');
        });
      });
      document.querySelectorAll('.js-collection-panel-back').forEach(function (backBtn) {
        backBtn.addEventListener('click', function () {
          var panel = this.closest('.js-mobile-collection-panel');
          // 关闭面板内所有展开的 tab
          panel.querySelectorAll('.js-mobile-tab.is-active').forEach(function (tab) {
            tab.classList.remove('is-active');
            tab.nextElementSibling.style.display = 'none';
            var arr = tab.querySelector('.js-mobile-tab-arrow');
            if (arr) arr.style.transform = 'rotate(0deg)';
          });
          panel.classList.remove('is-active');
        });
      });
      // 子面板内的 tab 折叠（手风琴：同一面板内只展开一个）
      document.querySelectorAll('.js-mobile-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var content = this.nextElementSibling;
          var arrow = this.querySelector('.js-mobile-tab-arrow');
          var isOpen = this.classList.contains('is-active');
          // 关闭同一面板内的所有其他 tab
          var panel = this.closest('.js-mobile-collection-panel');
          if (panel) {
            panel.querySelectorAll('.js-mobile-tab').forEach(function (other) {
              if (other !== tab) {
                other.classList.remove('is-active');
                other.nextElementSibling.style.display = 'none';
                var otherArrow = other.querySelector('.js-mobile-tab-arrow');
                if (otherArrow) otherArrow.style.transform = 'rotate(0deg)';
              }
            });
          }
          if (isOpen) {
            this.classList.remove('is-active');
            content.style.display = 'none';
            arrow.style.transform = 'rotate(0deg)';
          } else {
            this.classList.add('is-active');
            content.style.display = 'block';
            arrow.style.transform = 'rotate(90deg)';
            // 展开后滚动到合适位置（避开固定返回按钮）
            setTimeout(function () {
              var drawerBody = document.querySelector('#mobile-menu-drawer [data-scrollable]');
              var backBtn = panel.querySelector('.js-collection-panel-back');
              var offset = backBtn ? backBtn.offsetHeight : 56;
              if (drawerBody) {
                var tabTop = tab.getBoundingClientRect().top + drawerBody.scrollTop;
                var drawerTop = drawerBody.getBoundingClientRect().top;
                drawerBody.scrollTo({ top: tabTop - drawerTop - offset, behavior: 'smooth' });
              }
            }, 50);
          }
        });
      });
    })();

    // === 移动端菜单抽屉（手动控制，不依赖主题 Toggle） ===
    (function initMobileMenu() {
      var drawer = document.getElementById('mobile-menu-drawer');
      if (!drawer) return;

      var toggles = document.querySelectorAll('[data-js-toggle="mobile-menu-drawer"]');
      var body = document.body;
      var overlay = null;
      var isOpen = false;

      function open() {
        if (isOpen) return;
        isOpen = true;
        overlay = document.createElement('div');
        overlay.className = 'window-overlay';
        overlay.setAttribute('data-js-overlay', 'mobile-menu-drawer');
        overlay.setAttribute('data-js-window', 'overlay');
        body.appendChild(overlay);
        overlay.offsetHeight;
        overlay.classList.add('is-active');
        drawer.classList.add('is-active');
        body.classList.add('is-drawer-active');
        body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        toggles.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
      }

      function close() {
        if (!isOpen) return;
        isOpen = false;
        if (overlay) { overlay.classList.remove('is-active'); overlay.remove(); overlay = null; }
        drawer.classList.remove('is-active');
        body.classList.remove('is-drawer-active');
        body.style.overflow = '';
        document.documentElement.style.overflow = '';
        toggles.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          isOpen ? close() : open();
        });
      });

      document.addEventListener('click', function (e) {
        if (isOpen && e.target === overlay) close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) close();
      });
    })();
  });
})();
